
//General currency name. Use it when you want to show currency word
const currencyName = "تومان"

export enum BrandEnum {
    brandPageTitle = "لیست برندهای الانزا",
    notFoundBrand = 'برند مورد نظر یافت نشد!',
    filters="فیلترها"
}

export enum CategoryEnum {
    categoriesFor = " دسته بندی های",
    filters = "فیلترها",
    product = "کالا",
    notExistProduct = "محصولی موجود نیست",
    notEntered = " ",
}

export enum OrderProfileEnum {
    CURRENT = "جاری",
    SENT = ' ارسال شده',
    RETURNED = "مرجوع شده",
    CANCELLED = "لغو شده",
}

//payment type constants
export const PayType = {
    BANK_GATEWAY: "درگاه بانکی",
    CARD_TO_CARD: "کارت به کارت",
    VOUCHER_PRICE_COVER: "کد تخفیف صد درصدی",
    INSTALLMENT: "قسطی",
    WALLET: "کیف پول",
    BANK_GATEWAY_WALLET: "درگاه بانکی و کیف پول",
} as any;

export enum ProductQuantityEnum {
    lessThen = "کمتر از ۱۰ عدد در انبار باقی مانده",
    lessTwenty = "کمتر از ۲۰ عدد در انبار باقی مانده"
}

//Main purchase process system constants
export enum PurchaseProcessEnum {
//  Shopping bag page
    backToShop = "بازگشت به فروشگاه",
    noSendPricing = "محاسبه نشده",
    remainPriceToFreeDelivery =`${currencyName} مانده تا ارسال رایگان!`,
    deliveryIsFree = "ارسال شما رایگان می باشد.",
    basket = "سبد خرید",
    nextBuy = "خرید بعدی",
    completeBuy = "تکمیل خرید",
    totalPrice = "جمع قیمت کل",
    Toman = currencyName,
    basketIsEmpty = "  سبد خرید شما خالی است",
    viewProducts = "مشاهده محصولات",
    addToBasket = "افزودن به سبد خرید",
    remove = "حذف",
    seller = "فروشنده",
    count = "تعداد",
    transferToNextBuy = " انتقال به خرید بعدی",
    transferAllToNextBuy = "انتقال همه به سبد خرید",
    paymentDetails = " اطلاعات پرداخت",
    totalProductsPrices = "جمع قیمت محصولات",
    totalProductsDiscounts = "سود شما از خرید",
    addAllToBasket = "افزودن همه به سبد خرید",
//  Address select page
    backToSeeShoppingBag = "  بازگشت و مشاهده سبد خرید",
    postalCode = "کدپستی",
    notRegisterAddress = " آدرسی ثبت نشده است",
    selectDeliveryOption = " انتخاب شیوه ارسال",
    deliveryWithPost = " ارسال با پست",
    orderDescription = "توضیحات سفارش",
    optional = "اختیاری",
    chooseOtherAddress = " انتخاب ادرس دیگر",
    selectAddress = "آدرس خود را انتخاب  کنید",
    registeredAddress = "ثبت آدرس",
    edit = "  ویرایش",
    addressTitle = "عنوان ادرس",
    firstSelectProvince = "  ابتدا استان را انتخاب کنید",
    completeAddress = " آدرس کامل",
    unit = "واحد",
    ImReceiver = " گیرنده خودم هستم",
    name = "نام",
    lastName = " نام خانوادگی",
    phoneNumber = " شماره موبایل",
    landLine = " تلفن ثابت",
    sendingPrice = "هزینه ارسال",
    registerOrder = "ثبت سفارش",
    receiverDetails = "مشخصات گیرنده",
//  Checkout page
    orderDetails = " جزییات سفارش",
    receiverNameAndLastName = "نام و نام خانوادگی گیرنده:",
    receiverPhone = "شماره گیرنده",
    address = "آدرس",
    pelaque = "پلاک",
    deliverWay = "شیوه ارسال",
    backAndSeeDetails = " بازگشت و مشاهده اطلاعات",
    applyCode = " اعمال کد",
    confirm = "تایید",
    deliveryPrice = "هزینه ارسال",
    connectToPaymentGateway = "اتصال به درگاه پرداخت",
//  Transaction page
    successPurchaseTitle = "پرداخت شما با موفقیت انجام شد",
    successPurchaseTitleSecondary = "با تشکر از اعتماد شما",
    seeOrderText = "وضعیت سفارش",
    failedPurchaseTitle = "متاسفانه پرداخت شما ناموفق بود",
    checkoutAgain = "پرداخت دوباره",
    changePurchase = "تغییر روش پرداخت"
}

export enum ShoppingBagEnum  {
    isNotReservedShoppingBagText = "                کالا پس از پرداخت اینترنتی برای شما رزرو می‌شود. افزودن کالا به سبد به معنای رزرو قیمت یا تعداد نیست."
}

//Single product (product detail) constants
export enum SingleProductEnum {
    beFirstComment = " اولین نفری باشید که نظر میدهید",
    relatedProducts = "محصولات مشابه",
    otherVariations = " سایر تنوع ها",
    expirationDate = "تاریخ انقضا",
    sipplyForProducts = "تامین کالا",
    nextDay = "روز آینده",
    seller = "فروشنده",
    star = "امتیاز",
    customer = "خریدار",
    price = "قیمت",
    Toman = currencyName,
    SnapPayInstallmentPayment = " پرداخت قسطی اسنپ پی",
    monthlyInstallment = "۴ قسط ماهیانه",
    withoutFee = "بدون کارمزد",
    noExistProduct = "این کالا فعلا موجود نیست اما می‌توانیم به محض موجود شدن، به شما خبر دهیم.",
    cancelNotify = " لغو اطلاع رسانی",
    notifyProduct = "موجود شد به من اطلاع بده",
    addToWish = "افزودن به علاقمندی ها",
    removeFromWish = "حذف از  علاقمندی ها",
    share = "اشتراک گذاری",
    copyLink = " کپی کردن لینک",
    notExist = "ناموجود",
    addToBasketSuccessfully = "این کالا به سبد خرید اضافه شد",
    count = "تعداد",
    addToCart = "افزودن به سبد خرید",
    guarantee = "گارانتی",
    guaranteeOfAuthenticityOfProducts = "ضمانت اصالت کالا",
    sendToAllOfIran = "ارسال کالا به سراسر ایران",
    reasonableAndCompetitivePrice = "قیمت مناسب و قابل رقابت",
    returnProductTime = "۷ روز فرصت بازگشت کالا",
    productId = " شناسه کالا",
    ministryOfHealthCode = "کد وزارت بهداشت",
    lessView = "مشاهده کمتر",
    moreView = "مشاهده بیشتر",
    viewAll = "مشاهده همه",
    usersComments = " دیدگاه کاربران",
    addYourComment = " شما هم درباره این کالا دیدگاه ثبت کنید",
    addComment = "ثبت دیدگاه",
    yourComment = "دیدگاه شما",
    rating = "خرید این محصول را به دیگران...",
    comment = "دیدگاه",
    allComments = "همه دیدگاه ها",
    commentContent = " متن نظر",
    sendContent = "ارسال محتوا",
    add = "افزودن",
    submitACommentAnonymously = " ارسال دیدگاه به صورت ناشناس",
    commentDetails = "جزئیات دیدگاه",
    rulesAndRegulations = " قوانین و مقررات",
    from = " از",
    sort = "مرتب سازی",
    newest = "جدید ترین",
    mostUsefull = "مفیدترین",
    mostLiked = "بیشترین لایک",
    recommendTOBuy = "این محصول را توصیه میکنم",
    notRecommendTOBuy = " خرید این محصول را توصیه نمیکنم",
    notSure = "  مطمئن نیستم",
    adminAnswer = "پاسخ ادمین",
    allVariationsOfThisProduct = " همه تنوع های این محصول",
    product = "کالا",
    filter = " فیلتر",
    goToCart = "برو به سبد خرید",
    continueBuy = " ادامه خرید",
    reportComment = "  گزارش این دیدگاه",
    isThisCommentUsefull=" آیا این دیدگاه مفید بود؟",
    oldest="قدیمی ترین",
    images="تصاویر",
    NoCustomeImagesAvailable="تصویری بارگذاری نشده",
    noImageFromCustomers="تصویری از خریداران بارگذاری نشده است",
    loading="در حال بارگذاری...",
    productDescription="توضیحات کالا",
    productDetails="مشخصات کالا",
    notifMeIfProductBecomeAvailable="این کالا فعلا موجود نیست اما می‌توانیم به محض موجود شدن،به شما خبر دهیم.",
    previousPrice=" با قیمت قبلی",
    freeDelivery="ارسال رایگان"
}